import React from 'react'
import { get  } from 'lodash'
import Group from './group'
import DimensionsSelector from '../../dimensions/tagged-selector'

const Dimensions = ({
    value = {},
    onChange = () => {}
}) => {
    return (
        <React.Fragment>
            <Group label='Wellness Dimensions'>
                <DimensionsSelector
                    value={get(value, 'dimensions', [])}
                    onChange={dimensions => onChange({...value, dimensions })}
                />
            </Group>
        </React.Fragment>
    )
}

export default Dimensions